// MARK://dhk8/pos/components/TrainingModeBadge
// Loud, unmissable marker shown in the topbar (and as a thin band under it)
// whenever the shell is in training mode. Trainees and managers must never
// confuse a training session with a live one — hence the persistent striped
// band, not just a small pill.
//
// Renders nothing when training mode is off, so it's safe to mount
// unconditionally in PosLayout.

import { GraduationCap } from 'lucide-react'

import { useTrainingModeContext } from '../lib/training-mode.js'

export default function TrainingModeBadge() {
  const { training, setTrainingMode } = useTrainingModeContext()
  if (!training) return null

  return (
    <>
      <span className="pos-training-badge" role="status" aria-live="polite">
        <GraduationCap size={16} aria-hidden />
        <span className="pos-training-badge__label">Modo entrenamiento</span>
        <button
          type="button"
          className="pos-training-badge__exit"
          onClick={() => setTrainingMode(false)}
          aria-label="Salir del modo entrenamiento"
        >
          Salir
        </button>
      </span>
      {/* Full-width striped band, sits directly under the topbar. */}
      <div className="pos-training-band" aria-hidden />
      <style>{badgeStyles}</style>
    </>
  )
}

const badgeStyles = `
  .pos-training-badge {
    display: inline-flex;
    align-items: center;
    gap: var(--pos-space-2);
    height: 32px;
    padding: 0 var(--pos-space-2) 0 var(--pos-space-3);
    border-radius: var(--pos-radius-pill);
    background: var(--pos-warning);
    color: var(--pos-on-warning, #2A1B00);
    font-family: var(--font-display, var(--font-sans));
    font-size: var(--pos-text-xs);
    font-weight: var(--pos-weight-semibold);
    letter-spacing: var(--pos-tracking-snug);
    box-shadow: var(--pos-shadow-1);
    user-select: none;
  }
  .pos-training-badge__label { white-space: nowrap; }
  .pos-training-badge__exit {
    appearance: none;
    border: none;
    border-radius: var(--pos-radius-pill);
    height: 22px;
    padding: 0 var(--pos-space-2);
    background: color-mix(in oklch, var(--pos-on-warning, #2A1B00) 16%, transparent);
    color: var(--pos-on-warning, #2A1B00);
    font: inherit;
    font-size: var(--pos-text-xxs);
    font-weight: var(--pos-weight-semibold);
    cursor: pointer;
    transition: background var(--pos-duration-fast) var(--pos-ease-out);
  }
  .pos-training-badge__exit:hover { background: color-mix(in oklch, var(--pos-on-warning, #2A1B00) 28%, transparent); }

  .pos-training-band {
    position: absolute;
    left: 0; right: 0;
    top: var(--pos-topbar-h);
    height: 4px;
    background: repeating-linear-gradient(
      45deg,
      var(--pos-warning) 0 12px,
      var(--pos-on-warning, #2A1B00) 12px 24px
    );
    z-index: 10;
    pointer-events: none;
  }
`
